import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { examsAPI, coursesAPI } from "../services/api";
import "../styles/ExamsPage.css";

const ExamsPage = () => {
  const [exams, setExams] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchExams = async () => {
      const authToken = localStorage.getItem("authToken");
      if (!authToken) {
        alert("❌ لم يتم تسجيل الدخول. الرجاء تسجيل الدخول أولاً.");
        navigate("/login");
        return;
      }

      try {
        console.log("📡 جلب قائمة الامتحانات...");

        // Fetch all courses first
        const coursesResponse = await coursesAPI.getAll();
        const courses = coursesResponse.data;

        const parsedExams = [];

        for (const course of courses) {
          try {
            const examsResponse = await examsAPI.getByCourse(course.id);
            const examsList = examsResponse.data.map(exam => ({
              ...exam,
              courseName: course.title,
              courseId: course.id,
              exam_id: exam.id
            }));
            parsedExams.push(...examsList);
          } catch (err) {
            console.warn(`Failed to fetch exams for course ${course.id}`, err);
          }
        }

        setExams(parsedExams);
        setLoading(false);
      } catch (error) {
        console.error("❌ حدث خطأ أثناء تحميل الامتحانات:", error);
        setLoading(false);
      }
    };

    fetchExams();
  }, [navigate]);

  const handleDeleteExam = async (examId) => {
    if (!window.confirm("⚠️ هل أنت متأكد أنك تريد حذف هذا الامتحان؟ لا يمكن التراجع عن هذا الإجراء.")) {
      return;
    }

    try {
      await examsAPI.delete(examId);
      setExams((prevExams) => prevExams.filter((exam) => exam.exam_id !== examId));
      alert("✅ تم حذف الامتحان بنجاح!");
    } catch (error) {
      console.error("❌ خطأ أثناء حذف الامتحان:", error);
      alert("❌ حدث خطأ أثناء حذف الامتحان.");
    }
  };

  return (
    <div className="exams-container">
      <h2>📋 قائمة الامتحانات</h2>
      <button className="add-exam-btn" onClick={() => navigate("/add-exam-questions")}>
        ➕ إضافة امتحان جديد
      </button>

      {loading ? (
        <p>⏳ جارٍ تحميل الامتحانات...</p>
      ) : exams.length > 0 ? (
        <ul className="exam-list">
          {exams.map((exam) => (
            <li key={exam.exam_id} className="exam-item">
              <h3>{exam.title}</h3>
              <p>{exam.description}</p>
              <p><strong>📚 الدورة:</strong> {exam.courseName}</p>

              <div className="exam-buttons">
                <button onClick={() => navigate(`/exams/edit/${exam.exam_id}`)} className="edit-button" style={{ marginRight: '0.5rem' }}>
                  ✏️ تعديل
                </button>
                <button onClick={() => handleDeleteExam(exam.exam_id)} className="delete-button">
                  🗑️ حذف الامتحان
                </button>
              </div>
            </li>
          ))}
        </ul>
      ) : (
        <p>⚠️ لا يوجد امتحانات حتى الآن.</p>
      )}
    </div>
  );
};

export default ExamsPage;
